'use es6';

import { GAUGE } from 'reporting-visualizations/constants/visualizationTypes';
import { GaugeVisualizationRecord } from 'reporting-visualizations/visualizations/gauge/GaugeRecords';
import { fromJS } from 'immutable';
import { DefaultCategorical, GAUGE_PALETTES } from '../color/palettes';
import { List } from 'immutable';
import { getDiscreteColors } from '../color/assign';
import { getReportSingleValueEncoding } from '../../utils/report-visual-utils';
import { getColorPalette } from '../color/utils';
import { getPrimaryDataset } from 'reporting-data/v2/dataset/datasetGetters';
export const mapGaugeBandsToColors = (bands = List(), palette = DefaultCategorical) => {
  const discreteColors = getDiscreteColors(palette.get('scheme'), bands.size);
  return bands.reduce((acc, band, i) => {
    acc[i] = band.get('color') || discreteColors.get(i % discreteColors.size);
    return acc;
  }, {});
};
const toColor = (bands, colorOption = {}, brandKitPalettes) => {
  const palette = getColorPalette(colorOption, brandKitPalettes, GAUGE_PALETTES);
  const mappedBands = mapGaugeBandsToColors(bands, palette);
  return bands.map((band, i) => band.set('color', mappedBands[i]));
};
export const mapGaugeVisual = (report, datasets, reportOptions, params = {}) => {
  const primaryDataset = getPrimaryDataset(datasets);
  const visualOptions = report.getIn(['visual', 'options']);
  const {
    brandKitPalettes
  } = params;
  const dataColumn = report.getIn(['visual', 'encodings', 'single_value', 'column']);
  const compareColumn = report.getIn(['visual', 'encodings', 'compare', 'column']);
  const value = report.get('visual').encodings && getReportSingleValueEncoding(report);
  const bandsWithColors = toColor(visualOptions.get('bands'), visualOptions.get('color'), brandKitPalettes);
  return GaugeVisualizationRecord({
    type: GAUGE,
    data: fromJS({
      primary: primaryDataset
    }),
    layer: {
      dataset: 'primary',
      showRangeLabels: visualOptions.get('showRangeLabels'),
      plot: fromJS({
        min: visualOptions.getIn(['range', 'min']),
        max: visualOptions.getIn(['range', 'max']),
        bands: bandsWithColors
      }),
      dataColumn,
      compareColumn,
      valueFormattingOptions: value && value.get('options'),
      referenceLineValues: visualOptions.get('referenceLineValues')
    },
    style: {
      legendPosition: visualOptions.get('legendPosition'),
      legendWidth: visualOptions.get('legendWidth')
    }
  });
};